<template>
  <div v-if="initialized" class="simulator-app">
    <div class="simulator-alert" v-if="ie10()">
      ※表示、操作に問題がある場合は、最新のブラウザで利用ください。<br>
      それでも問題がある場合は、ブラウザキャッシュをクリアしてください。
    </div>
    <div class="simulator-header">
      <div class="simulator-header-row">
        <div class="simulator-header-col-1">
          <div class="simulator-header-label">間取名：</div>
          <input class="form-control form-control-sm" type="text" v-model="title">
        </div>
        <div class="simulator-header-col-2">
          <div class="simulator-header-label">間取公開：</div>
          <div class="custom-control custom-radio custom-control-inline mr-2">
            <input class="custom-control-input" id="madori1" type="radio" v-model="public" :value="true">
            <label class="custom-control-label" for="madori1">公開</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline mr-0">
            <input class="custom-control-input" id="madori2" type="radio" v-model="public" :value="false">
            <label class="custom-control-label" for="madori2">非公開</label>
          </div>
        </div>
        <div class="simulator-header-col-3">
          <div class="simulator-header-label">作成日：</div>
          <div>{{ madori.created ? dateFormat(madori.created) : '' }}</div>
        </div>
      </div>
      <div class="simulator-header-row">
        <div class="simulator-header-col-1">
          <div class="simulator-header-label">ニックネーム：</div>
          <div>{{ member && madori.is_own ? member.nick_name : madori.nick_name }}</div>
        </div>
        <div class="simulator-header-col-2">
          <div class="simulator-header-label">表示回数：</div>
          <div>{{ madori.display_count > 0 ? numberFormat(madori.display_count) + '回' : '' }}</div>
        </div>
        <div class="simulator-header-col-3">
          <div class="simulator-header-label">建物仕様：</div>
          <div>{{ madori.spec_selected && madori.spec_format ? madori.spec_formats.find(sf => sf.value == madori.spec_format).label : '' }}</div>
        </div>
      </div>
    </div>
    <div class="simulator-editor">
      <div class="editor-status">
        <div class="editor-status-area">
          <div class="editor-status-area-label">{{ floor }}階<br>床面積:</div>
          <div class="editor-status-area-value">{{ numberFormat(getFloorArea(floor), '0,0.[00]') }}㎡ (<small class="font-weight-bold">{{ numberFormat(getFloorTsubo(floor), '0,0.[0]') }}坪</small>)</div>
        </div>
        <div class="editor-status-area">
          <div class="editor-status-area-label">延べ床<br>面積:</div>
          <div class="editor-status-area-value">{{ numberFormat(allFloorArea, '0,0.[00]') }}㎡ (<small class="font-weight-bold">{{ numberFormat(allFloorTsubo, '0,0.[0]') }}坪</small>)</div>
        </div>
        <div class="editor-status-cost">
          <div class="editor-status-cost-body">
            <div class="editor-status-cost-body-label">概算建築費:</div>
            <div class="editor-status-cost-body-value">{{ numberFormat(price) }}<small>円</small></div>
          </div>
          <div class="editor-status-cost-link">
            <a :href="gaisan_url" target="_blank">
              概算費用算出について
              <svg class="align-baseline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 7" width="7" height="7"><path fill="currentColor" d="M6,3V2H5V3H0V4H5V5H6V4H7V3ZM4,1V2H5V1ZM3,0V1H4V0ZM4,6H5V5H4ZM3,7H4V6H3Z"/></svg>
            </a>
          </div>
        </div>
        <div class="editor-status-cost">
          <div class="editor-status-cost-body">
            <div class="editor-status-cost-body-label">炭素固定量:</div>
            <div class="editor-status-cost-body-value">{{ numberFormat(tanso, '0,0.[00]') }}<small>t</small></div>
          </div>
          <div class="editor-status-cost-link">
            <a :href="tanso_url" target="_blank">
              炭素固定量について
              <svg class="align-baseline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 7" width="7" height="7"><path fill="currentColor" d="M6,3V2H5V3H0V4H5V5H6V4H7V3ZM4,1V2H5V1ZM3,0V1H4V0ZM4,6H5V5H4ZM3,7H4V6H3Z"/></svg>
            </a>
          </div>
        </div>
      </div>
      <editor></editor>
      <div class="editor-palette">
        <palette-tabs></palette-tabs>
        <palette></palette>
      </div>
      <spec ref="spec"></spec>
      <inspector></inspector>
    </div>
    <div class="simulator-footer">
      <div class="d-flex justify-content-between pt-3">
        <div class="">
          <a class="icon-link" :href="help_url" target="_blank">
            <div class="icon-circle">
              <svg xmlns="http://www.w3.org/2000/svg" width="16.4" height="12.5" style="vertical-align: text-bottom;">
                <path fill="currentColor" d="M13.5 11.7c.5.1.9.2 1.1.4l1.8-1.1c-.7-.5-1.9-.8-3.5-.8-1.8 0-3.1.3-3.9.8v1.5c1-.6 2.3-.9 3.9-.9.1 0 .4.1.6.1M3.6 9.9c-1.7 0-2.9.3-3.6.8l1.8 1c.3-.1.7-.2 1.2-.3.3 0 .5-.1.7-.1 1.7 0 3 .2 4 .8v-1.4c-1-.5-2.3-.8-4.1-.8M3.9 0C2.3 0 1.1.5.1 1.6v7.6c.7-.5 1.9-.8 3.6-.8 1.8 0 3.1.3 4 .8V1.6C6.6.5 5.4 0 3.9 0m12.5 9.5V1.9C15.4.8 14.2.3 12.6.3c-1.5 0-2.7.5-3.7 1.6v7.6l.1-.1c.9-.4 2.1-.6 3.8-.6 1.6 0 2.7.2 3.5.6 0 0 .1 0 .1.1z"/>
              </svg>
            </div>
            使い方
          </a>
          <a class="icon-link" :href="koukai_madori_help_url" target="_blank">
            <div class="icon-circle">
              <svg xmlns="http://www.w3.org/2000/svg" width="15.4" height="12.2" style="vertical-align: text-bottom;">
                <path fill="currentColor" d="M15.4 12.2v-4H7.9v4h7.5m-8.6 0V6.8h8.6V0H0v12.2h6.8z"/>
              </svg>
            </div>
            公開間取
          </a>
        </div>
        <div class="d-flex">
          <template v-if="madori.is_own">
            <a v-if="madori.id" @click.prevent="clickSave(true)" href="#" class="btn btn-primary btn-sm font-weight-bold ml-3">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 14" width="13" height="14" style="vertical-align: middle;">
                <path fill="currentColor" d="M13,14V0H0v11.3L2.6,14H13 M10.6,0.9v7.1H2.4V0.9H10.6 M10.6,9.6v3.5h-4v-2H5.4v2H4.1V9.6H10.6z"/>
              </svg>
              別の間取として保存する
            </a>
            <a @click.prevent="clickSave()" href="#" class="btn btn-primary btn-sm font-weight-bold ml-3">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 14" width="13" height="14" style="vertical-align: middle;">
                <path fill="currentColor" d="M13,14V0H0v11.3L2.6,14H13 M10.6,0.9v7.1H2.4V0.9H10.6 M10.6,9.6v3.5h-4v-2H5.4v2H4.1V9.6H10.6z"/>
              </svg>
              保存する
            </a>
          </template>
          <template v-else>
            <a @click.prevent="clickSave(true)" href="#" class="btn btn-primary btn-sm font-weight-bold ml-3">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 14" width="13" height="14" style="vertical-align: middle;">
                <path fill="currentColor" d="M13,14V0H0v11.3L2.6,14H13 M10.6,0.9v7.1H2.4V0.9H10.6 M10.6,9.6v3.5h-4v-2H5.4v2H4.1V9.6H10.6z"/>
              </svg>
              自分の間取として保存する
            </a>
          </template>
          <a @click.prevent="clickExit" href="#" class="btn btn-primary btn-sm font-weight-bold ml-3">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.3 14" width="10.3" height="14" style="vertical-align: middle;">
              <path fill="currentColor" d="M6.5,5.3c1.6,0.6,2.4,1.8,2.4,3.5c0,1-0.4,1.9-1.1,2.7c-0.7,0.7-1.6,1.1-2.6,1.1c-1,0-1.9-0.4-2.6-1.1
                c-0.7-0.8-1.1-1.7-1.1-2.7c0-1.7,0.8-2.8,2.4-3.5V3.8C1.3,4.5,0,6.1,0,8.8c0,1.5,0.5,2.7,1.5,3.7c1,1,2.2,1.5,3.6,1.5
                c1.4,0,2.6-0.5,3.6-1.5c1-1,1.5-2.2,1.5-3.7c0-2.6-1.3-4.3-3.8-5V5.3 M5.8,0H4.4v8.9h1.3V0z"/>
            </svg>
            終了する
          </a>
          <a @click.prevent="clickPrint" href="#" class="btn btn-primary btn-sm font-weight-bold ml-3">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.3 15" width="12.14" height="14" style="vertical-align: middle;">
              <path fill="currentColor" d="M13.3,8.2h-1.1V0h-11v8.2H0v5.4h0.5V15h12.2v-1.4h0.5V8.2 M11.8,13.6V14H1.5v-0.4H11.8 M12.3,9.2v3.4H1V9.2
                H12.3 M11.1,0.9v7.3h-9V0.9H11.1 M10,7.2V6.4H3.3v0.8H10 M10,2.9V2.1H3.3v0.8H10 M10,5.1V4.2H3.3v0.8H10 M12,12.2V9.4H9.1v2.8H12
                z"/>
            </svg>
            印刷画面作成
          </a>
        </div>
      </div>
    </div>
    <item-shadow></item-shadow>
    <transition name="fade">
      <div v-if="dialogs.length > 0" class="simulator-overlay">
        <app-dialog v-for="dialog in dialogs" :key="dialog.key" :dialog="dialog"></app-dialog>
      </div>
    </transition>
    <form ref="print_form" :action="print_url" method="post" target="simprint" style="visibility: hidden">
      <input v-for="(value, name) in print_data" type="hidden" :name="name" :value="value" >
    </form>
  </div>
  <div v-else class="simulator-app">
    <div class="simulator-loading">読み込み中</div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import helpers from '../helpers'
import Editor from './Editor'
import Inspector from './Inspector'
import PaletteTabs from './palette/PaletteTabs'
import Palette from './palette/Palette'
import ItemShadow from './ItemShadow'
import Dialog from './Dialog'
import Spec from './Spec'
import { app, grid } from '../display'

export default {
  mixins: [helpers],
  components: {
    Editor,
    Inspector,
    PaletteTabs,
    Palette,
    ItemShadow,
    'app-dialog': Dialog,
    Spec,
  },
  data() {
    return {
      ...window.flashVars,
      print_data: null,
    }
  },
  computed: {
    ...mapState({
      madori: state => state.madori,
      member: state => state.member,
      floor: state => state.editor.floor,
    }),
    ...mapGetters('madori', [
      'price',
      'tanso',
      'getFloorArea',
      'getFloorTsubo',
      'allFloorArea',
      'allFloorTsubo',
    ]),
    ...mapGetters('dialog', [
      'dialogs',
    ]),
    initialized() {
      return this.$store.getters.initialized
    },
    title: {
      get() {
        return this.madori.title
      },
      set(value) {
        this.$store.commit('madori/updateTitle', value)
      },
    },
    public: {
      get() {
        return this.madori.public
      },
      set(value) {
        this.$store.commit('madori/updatePublic', value)
      },
    },
  },
  mounted() {
    let { savedata_id, member_id } = window.flashVars
    setTimeout(() => {
      this.initialize(savedata_id)
    }, 1000)
  },
  methods: {
    ...mapActions([
      'initialize',
    ]),
    ...mapActions('madori', [
      'postSaveItemData',
      'postSavePrintImages',
      'updateSpecSelected',
    ]),
    ...mapActions('dialog', [
      'addDialog',
    ]),
    clickSave(copy = false) {
      return new Promise((resolve, reject) => {
        let mode
        const cancel = new Error('User cancel save')
        return this.checkMemberDialog()
          .then(value => {
            if (value != 'cancel') {
              mode = value
              // 非メンバーは建築仕様設定の確認をしない
              return mode == 'member' ? this.checkSpecDialog() : Promise.resolve()
            } else {
              return Promise.reject(cancel)
            }
          })
          .then(value => {
            if (value != 'cancel') {
              return this.checkAreaAlert()
            } else {
              return Promise.reject(cancel)
            }
          })
          .then(value => {
            if (value != 'cancel') {
              return this.saveDialog(copy)
            } else {
              return Promise.reject(cancel)
            }
          })
          .then(savedata_id => {
            if (this.member == null) {
              let { register_url, login_url } = window.flashVars
              switch (mode) {
                case 'register':
                  window.location.href = register_url
                  break
                case 'login':
                  window.location.href = login_url
                  break
                default:
                  window.location.href = save_url
                  break
              }
            }
            resolve({mode, savedata_id})
          })
          .catch(reason => {
            if (reason != cancel) {
              this.openErrorDialog(reason)
              reject(reason)
            }
          })
      })
    },
    clickExit() {
      return new Promise((resolve, reject) => {
        return this.confirmSaveDialog()
          .then(save => {
            if (save == 'yes') {
              return this.clickSave()
                .then(({mode, savedata_id}) => {
                  resolve({save, mode, savedata_id})
                  setTimeout(() => {
                    window.close()
                  }, 1000)
                }, reason => {
                  reject(new Error('Save error'))
                })
            } else if (save == 'no') {
              resolve({save})
              window.close()
            } else {
              resolve({save})
            }
          })
      })
    },
    clickPrint() {
      return new Promise((resolve, reject) => {
        let dialog
        let printWindow = window.open('about:blank', this.$refs.print_form.target)
        return this.openCaptureWaitDialog()
          .then(waitDialog => {
            dialog = waitDialog
            return grid.captureImage()
          })
          .then(png_images => {
            return this.postSavePrintImages({png_images})
          })
          .then(data => {
            this.print_data = data
            this.$nextTick(() => {
              this.$refs.print_form.submit()
              this.print_data = null
              dialog.close().then(() => {
                resolve()
              })
            })
          }, reason => {
            printWindow.close()
            dialog.close().then(() => {
              reject(reason)
              this.openErrorDialog(reason)
            })
          })
      })
    },
    checkMemberDialog() {
      return new Promise((resolve, reject) => {
        if (this.member) {
          return resolve('member')
        }

        return this.addDialog({
          title: null,
          message: '間取を保存するにはフォレスタイルへのメンバー登録が必要です。「メンバー登録」をクリックすると現在作成中の間取が保存されて登録画面へ遷移します。既に登録済みの方は「ログイン」をクリックしてください。',
          icon: 'exclamation',
          actions: [
            { text: 'メンバー登録', class: 'primary' },
            { text: 'ログイン', class: 'primary' },
            { text: 'キャンセル', class: 'secondary' },
          ],
        }).then(response => {
            let { dialog, action, index } = response
            switch (action.text) {
              case 'メンバー登録':
                dialog.close().then(() => {
                  resolve('register')
                })
                break
              case 'ログイン':
                dialog.close().then(() => {
                  resolve('login')
                })
                break
              case 'キャンセル':
                dialog.close().then(() => {
                  resolve('cancel')
                })
                break
            }
        })
      })
    },
    checkSpecDialog() {
      return new Promise((resolve, reject) => {
        if (this.madori.spec_selected) {
          return resolve('spec_selected')
        }

        return this.addDialog({
          title: '建物仕様の設定はよろしいですか？',
          icon: 'exclamation',
          actions: [
            { text: '設定する', class: 'primary' },
            { text: 'そのまま保存する', class: 'primary' },
          ],
        }).then(response => {
          let { dialog, action, index } = response
          switch (action.text) {
            case '設定する':
              dialog.close().then(() => {
                this.$refs.spec.open()
                resolve('cancel')
              })
              break
            case 'そのまま保存する':
              dialog.close().then(() => {
                this.updateSpecSelected(true)
                resolve('save')
              })
              break
          }
        })
      })
    },
    checkAreaAlert() {
      return new Promise((resolve, reject) => {
        if (this.allFloorArea > 0) {
          return resolve('filled')
        }

        return this.addDialog({
          title: '保存する間取がありません。',
          icon: 'exclamation',
          actions: [
            { text: 'キャンセル', class: 'secondary' },
          ],
        }).then(response => {
          let { dialog, action, index } = response
          dialog.close().then(() => {
            resolve('cancel')
          })
        })
      })
    },
    saveDialog(copy) {
      return new Promise((resolve, reject) => {
        return this.addDialog({
          layout: 'wait',
          title: '只今保存しています',
          icon: 'saving',
          onOpen: dialog => {
            setTimeout(() => {
              grid.captureImage()
                .then(png_images => this.postSaveItemData({ png_images, copy }))
                .then(savedata_id => {
                  dialog.close().then(() => {
                    resolve(savedata_id)
                  })
                }, error => {
                  dialog.close().then(() => {
                    reject(error)
                  })
                })
            }, 1000)
          },
        })
      })
    },
    openCaptureWaitDialog() {
      return new Promise((resolve, reject) => {
        this.addDialog({
          layout: 'wait',
          title: '印刷画面作成中です',
          icon: 'printer',
          onOpen: dialog => {
            resolve(dialog)
          },
        })
      })
    },
    confirmSaveDialog() {
      return new Promise((resolve, reject) => {
        return this.addDialog({
          title: '閉じる前に保存しますか。',
          message: null,
          icon: 'exclamation',
          actions: [
            { text: 'はい', class: 'primary' },
            { text: 'いいえ', class: 'secondary' },
            { text: 'キャンセル', class: 'secondary' },
          ],
        }).then(response => {
            let { dialog, action, index } = response
            switch (action.text) {
              case 'はい':
                dialog.close().then(() => {
                  resolve('yes')
                })
                break
              case 'いいえ':
                dialog.close().then(() => {
                  resolve('no')
                })
                break
              case 'キャンセル':
                dialog.close().then(() => {
                  resolve('cancel')
                })
                break
            }
          })
      })
    },
    openErrorDialog(reason) {
      if (reason) {
        let { message, response } = reason
        return this.addDialog({
          title: 'エラーが発生しました。',
          message: response && response.data && response.data.error ? response.data.error : message,
          icon: 'exclamation',
          actions: [
            { text: 'OK', class: 'primary' },
          ],
        }).then(({ dialog, action, index }) => {
          dialog.close()
          return reason
        })
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// assets/js/components/Simulator.vue